<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="auto">
        <v-text-field
          v-model="input"
          label="Tìm giá"
          :placeholder="placeholder"
          prepend-inner-icon="mdi-magnify" 
          v-mask="'##/##/####'"
          filled
          dense
          flat
          solo
          clearable
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="monthSelected"
          :items="months"
          filled
          dense
          flat
          solo
          clearable
          label="Lọc theo tháng"
          prepend-inner-icon="mdi-filter"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="yearSelected"
          :items="years"
          item-text="value"
          filled
          dense
          flat
          solo
          clearable
          label="Lọc theo năm"
          prepend-inner-icon="mdi-filter"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="sortSelected"
          :items="sorts"
          filled
          dense
          flat
          solo
          clearable
          label="Sắp xếp theo"
          prepend-inner-icon="mdi-sort-calendar-descending"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
    </v-row>
    <h4 
      v-if="!loader && dates.length==0"
      class="text-center my-4 font-weight-light"
    >
      Không tìm thấy dữ liệu! Thử điều chỉnh lại các bộ lọc
    </h4>
    <h4 class="text-right mb-4 font-weight-light">
      Trang {{currentPage}} (Tổng {{totalPages}} Trang, {{totalItems}} bản tin)
    </h4>
    <v-row>
      <v-col
        v-for="(date, i) in dates" :key="i"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-sheet class="rounded-lg overflow-hidden">
          <v-hover v-slot="{ hover }">
            <v-card elevation="0"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              class="mcard"
            >
              <router-link
                :to="{ name: 'MarketView', params: { date: parseDate(date.ngay_cap_nhat) }}"
              >
                <v-img
                  :src="require(`@/assets/market/thumb3.png`)"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                  cover
                >
                  <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                  >
                    <v-spacer></v-spacer>
                    <v-icon small>mdi-eye</v-icon>
                    <span class="ml-1">{{ date.countview }}</span>
                  </v-app-bar>

                  <div class="dayname">
                    <div class="dntop">THỨ</div>
                    <div class="dnbot">{{date._dayname_marketprice}}</div>
                  </div>
                  <div class="minfo">
                    <div class="mitop">GIÁ NÔNG SẢN</div>
                    <div class="mibot">VẬT TƯ NÔNG NGHIỆP</div>
                    <div class="midate">{{date.ngay_cap_nhat}}</div>
                  </div>
                </v-img>
              </router-link>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    absolute
                    right
                    icon
                    :style="{bottom: '10px'}"
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent="exportData(date)"
                    :loading="date.loading"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Tải xuống</span>
              </v-tooltip>
              <v-card-subtitle class="pt-4">
                <v-icon color="primary">mdi-calendar</v-icon>
                Cập nhật lúc: 
                {{date._created_at}}
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import SystemSevice from '@/services/System';
  import FileSevice from '@/services/File';
  import { mapActions, mapState } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      tab: 0,
      loading: false,
      exportLoading: false,
      crumbs: [],
      dates: [],
      currentPage: 1,
      totalPages: 0,
      totalItems: 0,
      sorts: [
        {value: 'desc', text: 'Mới nhất - Cũ nhất'},
        {value: 'asc', text: 'Cũ nhất - Mới nhất'}
      ],
      sortSelected: null,
      months: [
        {value: '01', text: 'Tháng 1'},
        {value: '02', text: 'Tháng 2'},
        {value: '03', text: 'Tháng 3'},
        {value: '04', text: 'Tháng 4'},
        {value: '05', text: 'Tháng 5'},
        {value: '06', text: 'Tháng 6'},
        {value: '07', text: 'Tháng 7'},
        {value: '08', text: 'Tháng 8'},
        {value: '09', text: 'Tháng 9'},
        {value: '10', text: 'Tháng 10'},
        {value: '11', text: 'Tháng 11'},
        {value: '12', text: 'Tháng 12'},
      ],
      monthSelected: null,
      years: [],
      yearSelected: null,
      debouncedInput: '',
      timeout: null,
      placeholder: `Vd: 01/01/${(new Date()).getFullYear()}`
    }),
    computed: {
      ...mapState([
        'loader'
      ]),
      input: {
        get() {
          return this.debouncedInput;
        },
        set(val) {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.debouncedInput = val;
            this.getMarketDate();
          }, 1000)
        }
      }
    },
    mounted () {
      this.getAllNamFromMarket();
      this.getMarketDate();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Giá cả thị trường',
          disabled: true
        }
      ];
    },
    methods: {
      ...mapActions([
        'openSnackbar',
        'getLoader'
      ]),
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if(this.sortSelected){
          params["sort"] = this.sortSelected;
        }

        if(this.monthSelected){
          params["month"] = this.monthSelected;
        }

        if(this.yearSelected){
          params["year"] = this.yearSelected;
        }

        if(this.debouncedInput){
          params["keyword"] = this.debouncedInput;
        }

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.getMarketDate();
        this.$vuetify.goTo(0);
      },
      getMarketDate(){
        const app = this;
        const params = app.getRequestParams(
          app.currentPage,
        );
        app.getLoader(true);
        let request = {
          params: params
        };
        axios.get("api/v1/public/get-market-date", request)
          .then(response => {
            app.dates = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getAllNamFromMarket(){
        axios.get("api/v1/public/get-all-year-from-market")
          .then(response => {
            this.years = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      searchItems(){
        this.getMarketDate();
      },
      parseDate(d){
        return d.replaceAll('/', '');
      },
      exportData(date) {
        date.loading = true;
        const app =this;
        let ngay_cap_nhat = app.parseDate(date.ngay_cap_nhat);
        axios.get(
          `api/v1/public/market-export/${ngay_cap_nhat}`,
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `${ngay_cap_nhat}.xlsx`);
            date.loading = false;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải về thành công!'
            });
            SystemSevice.setSiteViewLocal({
              name: `MarketExport@${date.ngay_cap_nhat}`,
            });
          })
          .catch(function (error) {
            date.loading = false;
            app.openSnackbar({ type: 'error' });
          });
      }
    }
  }
</script>

<style>
.basil {
  background-color: #FFFBE6 !important;
}
.basil--text {
  color: #356859 !important;
}
#market_table thead tr th{
  font-weight: 900;
}
.mcard .dayname {
  position: absolute;
  left: 11px;
  text-align: center;
  font-weight: 700;
  bottom: 5px;
}
.mcard .dayname .dntop{
  background-color: #cd2222;
  color: #fff;
  padding: 5px 15px;
  border-top-right-radius: 4px;
  font-size: 8px;
  border-top-left-radius: 4px;
}
.mcard .dayname .dnbot{
  background-color: #fff;
  color: #cd2222;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  font-size: 17px;
}
.mcard .minfo {
  position: absolute;
  left: 5%;
  text-align: center;
  font-weight: 700;
  top: 20%;
  font-size: 20px;
}
.mcard .mitop {
  color: #cd2222;
  font-weight: 700;
  text-shadow: 2px 0 #fff, 
    -2px 0 #fff, 
    0 2px #fff, 
    0 -2px #fff, 
    1px 1px #fff, 
    -1px -1px #fff, 
    1px -1px #fff, 
    -1px 1px #fff;
}
.mcard .mibot {
  color: #cd2222;
  font-weight: 700;
  text-shadow: 2px 0 #fff, 
    -2px 0 #fff, 
    0 2px #fff, 
    0 -2px #fff, 
    1px 1px #fff, 
    -1px -1px #fff, 
    1px -1px #fff, 
    -1px 1px #fff;
}
.mcard .midate {
  font-size: 18px;
  text-shadow: 2px 0 #fff, 
    -2px 0 #fff, 
    0 2px #fff, 
    0 -2px #fff, 
    1px 1px #fff, 
    -1px -1px #fff, 
    1px -1px #fff, 
    -1px 1px #fff;
}
</style>